import Image from 'next/legacy/image';
import Link from 'next/link';
import type { ReactElement } from 'react';

export function EmailBlogBlock({ href }: { href: string }): ReactElement {
  return (
    <div className="flex justify-center font-secondary">
      <Link
        prefetch={process.env.NEXT_PUBLIC_PREFETCH === 'true'}
        href={href}
        passHref
        className="text-white no-underline"
      >
        <Image
          src="/images/blog-post-images-emailfriend-622x250.jpg"
          alt="group of product images for proteins"
          width={622}
          height={250}
          className="block max-w-full rounded-2xl"
        />
      </Link>
    </div>
  );
}
